import type { SVGProps } from 'react';

const SvgClassMoneyY = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_1234_62982)'>
      <path
        d='M12 23.9995C18.6274 23.9995 24 18.6269 24 11.9995C24 5.3721 18.6274 -0.000488281 12 -0.000488281C5.37258 -0.000488281 0 5.3721 0 11.9995C0 18.6269 5.37258 23.9995 12 23.9995Z'
        fill='#FFB91C'
      />
      <path
        d='M16.1865 5.41919C16.5075 4.9698 17.1316 4.86582 17.5811 5.18677C18.0305 5.50778 18.1345 6.13189 17.8135 6.5813L13.9424 12.0002H17C17.5523 12.0002 18 12.448 18 13.0002C17.9999 13.5524 17.5522 14.0002 17 14.0002H13V15.5002H17C17.5523 15.5002 18 15.948 18 16.5002C17.9999 17.0524 17.5522 17.5002 17 17.5002H13V19.5002C12.9999 20.0524 12.5522 20.5002 12 20.5002C11.4478 20.5002 11.0001 20.0524 11 19.5002V17.5002H7C6.44781 17.5002 6.00012 17.0524 6 16.5002C6 15.948 6.44773 15.5003 7 15.5002H11V14.0002H7C6.44781 14.0002 6.00012 13.5524 6 13.0002C6 12.448 6.44773 12.0003 7 12.0002H10.0557L6.18652 6.58911C5.86543 6.14001 5.96912 5.51492 6.41797 5.1936C6.86716 4.87245 7.49221 4.97598 7.81348 5.42505L12 11.2795L16.1865 5.41919Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1234_62982'>
        <rect width={24} height={24} rx={12} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassMoneyY;
